import { jsEscape } from 'utils/prevent-xss-attack'
import { AllAllowedCookies, AllowedParam, CookiesArray } from 'models/cookies'
import { setCookieLangFromUrl } from 'utils/current-language'
import { allowedParamsIds, allowedReferalParams } from 'config/allowed-cookies'
import sessionStorageService, { getValidParamsToStore } from 'services/session-service'
import { decodeUrlParams, doesUrlContainParam, getParamsFromUrl } from 'utils/urls'

export const setupCookies = (): void => {
  const decodedParams = decodeUrlParams(window.location.href)
  cookieService.setupCookiesFromURL(allowedParamsIds, decodedParams)
  setCookieLangFromUrl()
  sessionStorageService.saveCookiesFromURL(allowedReferalParams, decodedParams)
}

export const getAllowedCookies = (allowedCookies: AllAllowedCookies[]): CookiesArray => {
  const cookiesArray: CookiesArray = {}
  allowedCookies.forEach((item) => {
    const cookieValue = cookieService.getItem(item)
    if (cookieValue) cookiesArray[item] = cookieValue
  })
  return cookiesArray
}

export const getCookieDomain = (domain: string | null = null): string =>
  (domain || location.hostname).replace(/^(https?:\/\/)?(www\.)?/, '.')

const cookieService = {
  maximalCookieTTL: 90,
  setItem: (key: string, value: string, days = 365, domain = '', sameSite = 'Lax'): void => {
    const currentDate = new Date()
    currentDate.setTime(+currentDate + days * 86400000)

    document.cookie = `${key}=${value}; path=/; domain=${getCookieDomain(
      domain,
    )}; expires=${currentDate.toUTCString()}; SameSite=${sameSite}; Secure`
  },
  getItem: (name: string): string | null => {
    if (!document.cookie) return null
    const cookies = document.cookie.split('; ')

    const cookie = cookies.find((cookie) => cookie.startsWith(`${name}=`))
    if (!cookie) return null

    return cookie.substring(name.length + 1)
  },
  removeItem(key: string, domain?: string | null): void {
    if (document.cookie) {
      const zeroTime = new Date(0)
      document.cookie = `${key}=; expires=${zeroTime.toUTCString()}${domain ? `; domain=${domain}` : ''}; path=/`
    }
  },
  setCookieByParamUrl(paramKey: string, cookieKey: string): void {
    const urlParamsObject = getParamsFromUrl()
    if (doesUrlContainParam(paramKey, urlParamsObject))
      cookieService.setItem(cookieKey, urlParamsObject[paramKey], cookieService.maximalCookieTTL)
  },
  setupCookiesFromURL: (allowedParamsIds: AllowedParam[], decodedParams?: Record<string, string>): boolean => {
    const validParamsToStore = getValidParamsToStore(allowedParamsIds, decodedParams)
    let cookiesSet = false

    for (const paramName in validParamsToStore) {
      if (doesUrlContainParam(paramName, validParamsToStore)) {
        const cookieName = paramName === 'xchangerId' ? 'xchanger_id' : paramName

        cookieService.setItem(
          jsEscape(cookieName),
          jsEscape(validParamsToStore[paramName]),
          cookieService.maximalCookieTTL,
        )

        cookiesSet = true
      }
    }

    return cookiesSet
  },
  setupCookiesFromClient: (): void => {
    if (cookieService.getItem('ik_referrer')) {
      // TODO: Check is this code relevant for us.
      cookieService.setItem('ik_referrer', document.referrer, 730)
    }
  },
}

export default cookieService
